<template>
  <component
    :is="infoComponent"
    v-if="infoComponent !== null"
    :request="request"
  />
  <div v-else>
    Unknown tenant
  </div>
</template>

<script>
import AMInformation from '@/components/request/amsterdam/Information.vue';
import PNCInformation from '@/components/request/park-n-charge/Information.vue';
import GORALInformation from '@/components/request/go-ral/Information.vue';
import OPCInformation from '@/components/request/opcharge/Information.vue';
import VLAInformation from '@/components/request/vlaanderen/Information.vue';
import DHAInformation from '@/components/request/den-hartog/Information.vue';
import DCHInformation from '@/components/request/dutch-charge/Information.vue';
import PWGInformation from '@/components/request/power-go/Information.vue';
import OCHInformation from '@/components/request/orange-charging/Information.vue';
import EVTInformation from '@/components/request/evtools/Information.vue';
import STPInformation from '@/components/request/stella-power/Information.vue';
import MKEInformation from '@/components/request/mick-e/Information.vue';
import GRNInformation from '@/components/request/groningen/Information.vue';
import SYCInformation from '@/components/request/sycada/Information.vue';
import ARNInformation from '@/components/request/arnhem/Information.vue';
import WBDInformation from '@/components/request/wijk-bij-duurstede/Information.vue';
import WOWInformation from '@/components/request/woerden-oudewater/Information.vue';
import UBTInformation from '@/components/request/ubitricity/Information.vue';
import OVFInformation from '@/components/request/ovef/Information.vue';
import MCHInformation from '@/components/request/mechelen/Information.vue';
import ENGInformation from '@/components/request/engie/Information.vue';

export default {
  components: {
    PNCInformation,
    GORALInformation,
    OPCInformation,
    AMInformation,
    VLAInformation,
    DHAInformation,
    DCHInformation,
    PWGInformation,
    OCHInformation,
    STPInformation,
    MKEInformation,
    EVTInformation,
    GRNInformation,
    SYCInformation,
    ARNInformation,
    WBDInformation,
    WOWInformation,
    UBTInformation,
    OVFInformation,
    MCHInformation,
    ENGInformation
  },
  props: {
    request: {
      type: Object,
      required: true
    }
  },
  computed: {
    infoComponent() {
      switch (process.env.VUE_APP_TENANT) {
        case 'park-n-charge':
          return 'PNCInformation';
        case 'go-ral':
          return 'GORALInformation';
        case 'den-hartog':
          return 'DHAInformation';
        case 'dutch-charge':
          return 'DCHInformation';
        case 'power-go':
          return 'PWGInformation';
        case 'orange-charging':
          return 'OCHInformation';
        case 'stella-power':
          return 'STPInformation'
        case 'mick-e':
          return 'MKEInformation'
        case 'opcharge':
          return 'OPCInformation';
        case 'amsterdam':
          return 'AMInformation';
        case 'vlaanderen':
          return 'VLAInformation';
        case 'evtools':
          return 'EVTInformation';
        case 'groningen':
          return 'GRNInformation';
        case 'sycada':
          return 'SYCInformation';
        case 'arnhem':
          return 'ARNInformation';
        case 'wijk-bij-duurstede':
          return 'WBDInformation';
        case 'woerden-oudewater':
          return 'WOWInformation';
        case 'ubitricity':
          return 'UBTInformation';
        case 'ovef':
          return 'OVFInformation';
        case 'mechelen':
          return 'MCHInformation';
        case 'engie':
          return 'ENGInformation';
      }

      return null;
    }
  }
};
</script>
